<template>
  <div>
    <WrapperPreviewCategory customClass="section-preview_lk">
      <GridTable
        :data-rows="serverData"
        :headers="headers.massive"
        :headers-for-rows="headersForRows"
        :loading-data="loadingData"
        :num-cols="headers.countCells"
        :max-table-height="maxTableHeight"
        gap="0"
        ref="npg-table"
        key="form-5-22"
      >
        <template v-for="(item) in headersForRows" v-slot:[item.dataField]="slotData">
          <slot :name="item.dataField" v-bind="slotData">
            {{ slotData.row[item.dataField] ? slotData.row[item.dataField] : slotData.row.text }}
            <v-btn small icon @click="openTooltip(item.dataField)" v-if="slotData.row[item.dataField]">
              <v-icon
                :size="15"
                class="grey-light-color__important "
              >
                mdi-information
              </v-icon>
            </v-btn>
          </slot>
        </template>
      </GridTable>
    </WrapperPreviewCategory>
    <tooltip-forms5-dialog
      ref="tooltip-dialog"
      :data-field="dataFieldTooltip"
    >
    </tooltip-forms5-dialog>
    <appeal-dialog
      ref="appeal-dialog"
      :appeal-id="appealId"
      :file-id="fileId"
      :appeal="appealCell"
      :value="appealValue"
      :appeals-arr="appealsArr"
      :appeal-info="appealInfo"
      @saved-value="saveValue($event)"
      @closing-dialog="closingAppealDialog"
    ></appeal-dialog>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import form522 from "./configs/form5-22";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import tooltipForms5Dialog from "@/components/Dialogs/tooltipForms5Dialog";
import {setAppealDialog} from "@/mixins/forms5/appealDialog";
// import FivesTableCell from "@/components/fields/fivesTableCell";
import appealDialog from "@/components/Dialogs/appealDialog";
import {fiveFormsMixin} from "@/mixins/formUsl";
import Form5Controller from "@/controllers/Organizations/Form5Controller";
import {mapGetters} from "vuex";

export default {
  name: "form22",
  mixins: [headerTooltipFunctions, setAppealDialog, fiveFormsMixin],
  components: {/*FivesTableCell,*/ WrapperPreviewCategory, GridTable, tooltipForms5Dialog, appealDialog},
  props: {
    chosenChildOrg: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      serverData: [],
      loadingData: false,
      changingHeaders: false,
      headers: form522,
      loadingMenu: {value: false, id: ''},
      full: false
    }
  },
  created() {
    if (this.get_spr_data_usl_loading === false)
      this.loadingDataTable();
  },
  watch: {
    getChosenOrgId() {
      this.loadingDataTable();
    }
  },
  computed: {
    ...mapGetters('spr', {getChosenOrgId: 'getChosenOrgId'}),
    maxTableHeight() {
      return window.innerHeight - 225 + 'px'
    },
    headersForRows() {
      return this.headers.massive.filter(el => el.variable).map(el => {
        return {
          ...el,
          styles: (row) => {
            if (el.dataField !== 'npg')
              return row.uslName ? 'display: none;' : 'justify-content: unset; text-align: center; '
            else
              return ''
          },
          colsDataCalc: (row) => {
            if (el.dataField !== 'npg')
              return 1;
            else
              return row.uslName ? 7 : 1;
          },
          props: (row, cell, loading) => {
            return {
              value: row[cell.dataField],
              title: '',
              cell: cell,
              id: row.id,
              row: row,
              loading: loading,
            }
          }
        }
      })
    },
  },
  methods: {
    loadFullInfo() {
      this.full = !this.full;
      this.loadingDataTable()
    },
    async loadingDataTable() {
      this.loadingData = true;
      this.serverData = [];
      try {
        const array = await Form5Controller.getForm('part22', this.full, false, this.chosenChildOrg?.id);
        
        const obj1 = {
          text: 'Бакалавриат',
          qredb20Vp1: array['qredb20Vp1'],
          qredb21Vp1: array['qredb21Vp1'],
          qredb22Vp1: array['qredb22Vp1'],
          qesfb20Vp1: array['qesfb20Vp1'],
          qesfb21Vp1: array['qesfb21Vp1'],
          qesfb22Vp1: array['qesfb22Vp1'],
          qpsfb20Vp1: array['qpsfb20Vp1'],
          qpsfb21Vp1: array['qpsfb21Vp1'],
          qpsfb22Vp1: array['qpsfb22Vp1']
        }
        const obj2 = {
          text: 'Специалитет',
          qredb20Vp1: array['qreds20Vp1'],
          qredb21Vp1: array['qreds21Vp1'],
          qredb22Vp1: array['qreds22Vp1'],
          qesfb20Vp1: array['qesfs20Vp1'],
          qesfb21Vp1: array['qesfs21Vp1'],
          qesfb22Vp1: array['qesfs22Vp1'],
          qpsfb20Vp1: array['qpsfs20Vp1'],
          qpsfb21Vp1: array['qpsfs21Vp1'],
          qpsfb22Vp1: array['qpsfs22Vp1']
        }
        const obj3 = {
          text: 'Магистратура',
          qredb20Vp1: array['qredm20Vp1'],
          qredb21Vp1: array['qredm21Vp1'],
          qredb22Vp1: array['qredm22Vp1'],
          qesfb20Vp1: array['qesfm20Vp1'],
          qesfb21Vp1: array['qesfm21Vp1'],
          qesfb22Vp1: array['qesfm22Vp1'],
          qpsfb20Vp1: array['qpsfm20Vp1'],
          qpsfb21Vp1: array['qpsfm21Vp1'],
          qpsfb22Vp1: array['qpsfm22Vp1']
        }
        this.serverData.push(obj1, obj2, obj3);
        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },
  },
}
</script>

<style scoped>

</style>